module.exports = __webpack_public_path__ + "assets/img/marriage-verify-img.0ffe4d8d.png";